module.exports = __webpack_public_path__ + "static/media/BakingCalculator.192bb6f4.png";